import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Enumify } from "enumify-ts";
import { isStringNotBlank } from "../../../swzutils/TypeUtils";
import { CustomerProjectStageEnum } from "../routes/orders/api/Representation";
import { Tag } from "antd";
class CustomerProjectStage extends Enumify() {
    description;
    static LIVE = new CustomerProjectStage("Live");
    static TENDER = new CustomerProjectStage("Tender");
    static AWARDED = new CustomerProjectStage("Awarded");
    static RATES_ONLY = new CustomerProjectStage("Rates only");
    static PRE_ORDER = new CustomerProjectStage("Pre Order");
    static ORDER = new CustomerProjectStage("Order");
    static DIRECT = new CustomerProjectStage("Direct");
    static MARKETPLACE = new CustomerProjectStage("Marketplace");
    static _ = CustomerProjectStage._closeEnum();
    constructor(description) {
        super();
        this.description = description;
    }
    static filtersArray() {
        return CustomerProjectStage.values.map(t => {
            return { text: t.description, value: t.key };
        });
    }
    static selectOptionsArray() {
        return CustomerProjectStage.values.map(r => {
            return {
                label: r.description,
                value: r.key
            };
        });
    }
    static renderEnum(enumValue) {
        if (enumValue && isStringNotBlank(enumValue)) {
            const enumObj = CustomerProjectStage.valueOf(enumValue);
            if (enumObj) {
                return enumObj.description;
            }
            return (_jsxs("span", { className: "error-text", children: ["Unknown: ", enumValue] }));
        }
        return null;
    }
    renderTag() {
        return _jsx(Tag, { children: this.description });
    }
}
export default CustomerProjectStage;
